<script setup lang="ts">
import { inject } from 'vue'
import PageTitle from '@/components/PageTitle.vue'
import { customElementPropsKey } from '@/types/customElementProps.types'

const templateProps = inject(customElementPropsKey)
</script>

<template>
  <div>
    <PageTitle
      :title="$t('required-action.verify-email.card.title')"
      :subtitle="$t('required-action.verify-email.info')"
    />

    <v-btn block variant="text" :href="templateProps?.loginActionUrl">{{
      $t('required-action.verify-email.resend-email.button')
    }}</v-btn>
  </div>
</template>
